import {each} from "lodash";

/**
 * Check if any DatePicker input element (year, month, day, ...) is invalid
 *
 * @param {HTMLElement} datePickerElement - Datepicker input element.
 * @param {boolean} [includeEmpty=false] - If true, empty input elements will be considered invalid.
 * @return {boolean}
 */
export const isAnyInputInvalid = (datePickerElement, includeEmpty) => {
	let result = false;
	each(datePickerElement.querySelectorAll(".react-date-picker__inputGroup input:not([name=''])"), 
		input => {
			if (!input.checkValidity() || (includeEmpty && input.value === '')) {
				result = true;
				return false;
			}
		}
	);
	return result;
};

/**
 * Get the list of all invalid DatePicker input elements (year, month, day, ...)
 *
 * @param {HTMLElement} datePickerElement - Datepicker input element.
 * @param {boolean} [includeEmpty=false] - If true, empty input elements will be considered invalid.
 * @return {HTMLElement[]}
 */
export const getInvalidInputs = (datePickerElement, includeEmpty = false) => {
	let result = [];
	each(datePickerElement.querySelectorAll(".react-date-picker__inputGroup input:not([name=''])"), 
		input => { if (!input.checkValidity() || (includeEmpty && input.value === '')) result.push(input); }
	);
	return result;
}

/**
 * Check if all DatetimePicker input elements (year, month, day, ...) are empty
 *
 * @param {HTMLElement} datetimePickerElement - Datepicker input element.
 * @return {boolean}
 */
export const areAllInputsEmpty = datetimePickerElement => {
	return !datetimePickerElement.querySelector(".react-date-picker__inputGroup input:not([name=''])")?.value;
};